import axios from '../../http/axios/index.js'

// const API_URL = 'https://selfie.cash'
const API_URL = 'https://selfie.cash'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  fetchAllUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/allusers`)
        .then((response) => {
          commit('SET_USERS', response.data.allUser)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUserReferral({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/getAllUserReferrals`)
        .then((response) => {
          console.log(response.data)
          
          resolve(response)

        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPrivateReferral({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/getAllPrivateReferrals`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUserWithId({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/usersWithId`)
        .then((response) => {
          commit('SET_USERS', response.data.allUser)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/users`)
        .then((response) => {
          commit('SET_USERS', response.data.allUser)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  paytransaction({ commit }, id) {
    console.log("Asdf")
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/api/management/paytransaction/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {reject(error)})
    })
  },
  fetchUser(context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/users/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {reject(error) })
    })
  },
  fetchUserWithPayment({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/usersWithPayment`)
        .then((response) => {
          commit('SET_USERS', response.data.allUser)
          resolve(response)
        })
        .catch((error) => { 
          
          reject(error) })
    })
  },
  fetchUserTransaction({ commit }, transactionId) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/gettransaction/${transactionId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {reject(error) })
    })
    
  },
  removeRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/api/management/deleteuser/${id}`)
        .then((response) => {
          commit('REMOVE_RECORD', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", payload.file); // appending file
      formData.append("_id", payload.userDetails._id);
      formData.append("firstname", payload.userDetails.firstname);
      formData.append("lastname", payload.userDetails.lastname);
      formData.append("userId", payload.userDetails.userId);
      formData.append("role", payload.userDetails.role);
      formData.append("birthday", payload.userDetails.birthday);
      formData.append("email", payload.userDetails.email);
      formData.append("country", payload.userDetails.country);
      axios
        .post("/api/management/updateUser", formData)
        .then((res) => {
          commit('UPDATE_USER', { user: payload.userDetails, path: res.data.file ? res.data.path : '' })
          this._vm.$vs.notify({
            color: "success",
            title: "User Update Success!",
            text: res.data.message,
          });
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  updatePayment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("_id", payload._id);
      formData.append("account", payload.account);
      formData.append("country", payload.country);
      formData.append("currency", payload.currency);
      formData.append("reason", payload.reason);
      formData.append("status", payload.status);
      formData.append("type", payload.type);  
      
      axios
        .post("/api/management/updatePayment", formData)
        .then((res) => {
          commit('UPDATE_USER', { user: payload.userDetails, path: res.data.file ? res.data.path : '' })
          this._vm.$vs.notify({
            color: "success",
            title: "User Update Success!",
            text: res.data.message,
          });
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  approveRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/api/management/usersApprove/${id}`)
        .then((response) => {
          this._vm.$vs.notify({
            color: "success",
            title: "User Approved",
            text: response.data.message,
          });
          commit('APPROVE_USER', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  rejectRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/api/management/usersReject/${id}`)
        .then((response) => {
          this._vm.$vs.notify({
            color: "danger",
            title: "User Rejected",
            text: response.data.message,
          });
          commit('REJECT_USER', id)
          // commit('REJECT_')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  changeStatus({commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/api/management/changeStatus`, data)
        .then ((response) => {
          this._vm.$vs.notify({
            color: data.status === 'Approved' ? "success" : "danger",
            title: `Profile Information is ${data.status}`,
            text: response.data.message,
          });

          commit('CHANGE_STATUS', data)
          resolve(response)
        })
        .catch((error) => {reject(error)})
    })
  },

  changeReferStatus({commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/api/management/changeReferStatus`, data)
      .then ((response) => {
        this._vm.$vs.notify({
          color: data.status === 'Approved' ? "success" : "danger",
          title: `Refer is ${data.status}`,
          text: response.data.message,
        });
        commit('CHANGE_REFER_STATUS', data)
        resolve(response)
      })
      .catch((error) => {reject(error)})
    })
  },
  getDashboardData({ commit }, url) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/dashboard/${url}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
